import { createSlice } from "@reduxjs/toolkit";
import { getGroupProductFeatureAPI } from "../../services/getGroupProductFeatures";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getGroupProductFeatureSlice = createSlice({
  name: "getGroupProductFeatureState",
  initialState: data,
  reducers: {
    getGroupProductFeatureInfo(state) {
      state.isLoading = true;
    },
    getGroupProductFeatureSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getGroupProductFeatureFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getGroupProductFeatureReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getGroupProductFeatureHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(getGroupProductFeatureAction.getGroupProductFeatureInfo());
    const response = await getGroupProductFeatureAPI(data, options);
    dispatch(
      getGroupProductFeatureAction.getGroupProductFeatureSuccess(response)
    );
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e?.response?.data?.message || e || "Something went wrong." };
    dispatch(
      getGroupProductFeatureAction.getGroupProductFeatureFailure(failurePayload)
    );
  }
};
export default getGroupProductFeatureSlice.reducer;
export const getGroupProductFeatureAction = getGroupProductFeatureSlice.actions;
